import React from 'react';
import { Flex } from "@chakra-ui/react";
import { displayReactIcon } from '../../../../digital-sales-room/helpers/dsr-display-helpers';


export default function LaunchdeckTag(props) {
	
	const { label, w, width, px, py, border, borderColor, textTransform, bg, fontSize, color, fontWeight, cursor, onClick, reactIcon } = props;
	const isFullWidth = (width==='100%' || w==='100%') ? true : false;

	return (
		<Flex
			display={!isFullWidth && 'inline-flex'}
			px={px ? px : "1em"}
			py={py ? py : '0.4em'}
			rounded='18.75em'
			fontSize={fontSize ? fontSize : "0.65em"}
			bg={bg ? bg : "#f5f6f7"}
			border={border && border}
			borderColor={borderColor ? borderColor : "#ccd0d5"}
			color={color ? color : "#4b4f56"}
			textTransform={textTransform ? textTransform : ''}
			w={width ? width : w ? w : ''}
			fontWeight={fontWeight ? fontWeight : '400'}
			justify='center'
			alignItems='center'
			whiteSpace='pre'
			onClick={onClick && onClick}
			cursor={cursor ? cursor : onClick ? 'pointer' : 'default'}
			gap={reactIcon && '0.5em'}
		>
			{reactIcon && displayReactIcon(reactIcon, '1.5em')}
			{label ? label : props.children}		
		</Flex>

	)
	
}
